import all from './reducer-all';
import active from './reducer-active';
import search from './reducer-search';
import recommendations from './recommendations/reducer';

import { combineReducers } from 'redux';

export default combineReducers({
  all,
  active,
  search,
  recommendations,
});
